import * as Popover from '@radix-ui/react-popover';
import { tk, tok, zIndex } from '@sunwebgroup/ui-components';

import { styled } from 'styled-components';

export const PopoverContent = styled(Popover.Content)`
  background: ${tk('color_semantic_bg')};
  border-radius: ${tok('primitives_space_16')}px;
  box-shadow: ${tk('shadow_lg_bottom')};
  color: ${tk('color_semantic_text')};
  display: block;
  min-width: 340px;
  overflow: hidden;
  padding: ${tk('spacing_lg')};

  // Note: z-index is not set to popver, as it needs to overlap with heroContent
  z-index: ${zIndex.modalOrMobilePopover};
`;

export const PopoverBody = styled.div`
  margin: -${tk('spacing_lg')};
  max-height: min(var(--radix-popover-content-available-height), 640px);
  overflow-y: auto;
  padding: 0;

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  /* Show shadow when content overflows */
  background:
    linear-gradient(rgba(255, 255, 255, 0), white 70%) 0 calc(100% - 76px),
    linear-gradient(rgba(0, 0, 0, 0.08), rgba(255, 255, 255, 0) 70%) 0 calc(100% - 76px);
  background-repeat: no-repeat;
  background-color: ${tk('color_semantic_bg')};
  background-size:
    100% 15px,
    100% 6px;
  background-attachment: local, scroll;
`;
export interface Options {
  isAvailable?: boolean;
  name: string;
  value: string;
  resultsCount?: number | string;
}
